import axios from 'axios';

// API ve Base URL Tanımları (Canlı ortam için dinamik)
let apiUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000/api';

// Güvenlik Düzeltmesi: Eğer canlı sunucuya bağlanılıyorsa ve HTTP ise HTTPS'e çevir (CORS Redirect hatasını önler)
if (!apiUrl.includes('localhost') && !apiUrl.includes('127.0.0.1') && apiUrl.startsWith('http://')) {
  apiUrl = apiUrl.replace('http://', 'https://');
}

export const API_URL = apiUrl;
export const BASE_URL = API_URL.replace(/\/api\/?$/, ''); // /api uzantısını kaldırarak kök adresi bulur

// Axios örneği oluştur
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// İstek (Request) Interceptor - Her isteğe Token ekler
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Yanıt (Response) Interceptor - Yetki hatası varsa çıkış yaptırır
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Sadece 401 (Unauthorized) durumunda çıkış yap (Token geçersiz/süresi dolmuş)
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
